import React, { useState } from 'react';
import axios from '../../../utils/axios';
import { TextField, Button, Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Footer from '../../Partial/footer/footer';
import Navbar from '../../Partial/navbar/Navbar';

const AddDealForm = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [content, setContent] = useState('');
  const [imageLink, setImageLink] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newDeal = { title, description, imageLink, content };

    try {
      const response = await axios.post('/deals', newDeal);
      if (response.data) {
        // After deal is added, refresh the page
        // window.location.reload();  // Reload the page to fetch the new deal from the backend
        navigate('/discover');  // Redirect to /discover
      }
    } catch (error) {
      console.error('Error adding deal:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/discover');  // Navigate to discover page when cancel is clicked
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Navbar/>
      <div className="container-fluid">
      <h2>Add a New Post</h2>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description"
              fullWidth
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Content"
              fullWidth
              multiline
              rows={4}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Image Link"
              fullWidth
              value={imageLink}
              onChange={(e) => setImageLink(e.target.value)}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? 'Submitting...' : 'Add Post'}
            </Button>
            <Button variant="outlined" style={{ marginLeft: '10px' }} onClick={handleCancel} >
                  Cancel
            </Button>
          </Grid>
        </Grid>
      </form>
      </div>
      <Footer/>
    </Container>
  );
};

export default AddDealForm;
